import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { ImageCardCollection } from 'Components/ImageCardCollection';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 55px 24px;
  background-color: ${theme.colors.neutral[200]};

  ${legacyTheme.breakpoints.up('md')} {
    padding: 120px 100px;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    padding: 120px 200px;
  }
`;

const StyledTitle = styled(Typography)`
  color: ${theme.colors.primary[400]};
`;

const EventsBlock = ({ title, list }) => {
  return (
    <Wrapper>
      <StyledTitle align="center" markupName="h4" variant="mono1">
        {title}
      </StyledTitle>
      <Spacer size={37} />
      <ImageCardCollection
        cardColor={theme.colors.neutral[100]}
        fixedHeight
        list={list}
        titleTag="h5"
      />
    </Wrapper>
  );
};

EventsBlock.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subTitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      images: PropTypes.shape({
        mobile: srcOrNextImageProp,
        desktop: srcOrNextImageProp,
      }).isRequired,
    })
  ).isRequired,
};

export default EventsBlock;
